import React from 'react';
import {connect} from 'react-redux';
import {UserActions} from '../../actions';
import {Api} from '../../api';
import {Subjekt} from '../subjekt';

const mapStateToProps = state => ({
    subjekt: state.app.user.data.subjekt,
});

const mapDispatchToProps = dispatch => ({
    onChange: newSubjekt => {
        return Api.saveUserSubjekt(newSubjekt).then(savedSubjekt => {
            dispatch(UserActions.setSubjekt(savedSubjekt));
        });
    },
    onDelete: () => {
        return Api.deleteUserSubjekt().then(() => {
            dispatch(UserActions.deleteSubjekt());
        });
    },
    dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Subjekt);
